/* Peachy Story (sections/peachy-story.liquid). Turns the stacked scenes into a
   one-scene-at-a-time story: progress bar, back, skip to offer, analytics, and
   an offer CTA that closes the story and scrolls to the real buy box.
   Tap the right side of a scene to go forward, the left third to go back.
   Opt out with ?story=off (or a #hash link), useful for QA of the page below.
   The Alia popup loader is held by the inline script in the section while
   the story is open and released data-popup-delay seconds after Claim (Alia's
   timer counts from page load, so this puts its usual delay after Claim). */
(function () {
  function track(prefix, name, extra) {
    var ev = prefix + '_' + name;
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, extra || {})); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', ev, extra || {}); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, extra || {}); } catch (e) {}
  }

  function init(root) {
    if (!root || root.__pst) return;
    root.__pst = true;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pst-step]'));
    if (!steps.length) return;
    var segs = Array.prototype.slice.call(root.querySelectorAll('.pst-bar__seg'));
    var back = root.querySelector('[data-pst-back]');
    var skip = root.querySelector('[data-pst-skip]');
    var prefix = root.getAttribute('data-event-prefix') || 'story';
    var targetSel = root.getAttribute('data-offer-target') || '#peachy-buy-box';
    var designMode = !!(window.Shopify && Shopify.designMode);
    var params = new URLSearchParams(location.search);

    // Skip the story entirely: explicit opt-out or a deep link to a section.
    var optOut = params.get('story') === 'off' || (location.hash && location.hash.length > 1);
    root.classList.add('pst--live');
    if (optOut) { root.classList.add('pst--closed'); releasePopups(); return; }

    var cur = 0;
    var furthest = 0;
    document.documentElement.classList.add('pst-open');

    function loadImg(step) {
      if (!step) return;
      Array.prototype.forEach.call(step.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
      var v = step.querySelector('video[preload="none"]');
      if (v) v.preload = 'auto';
    }

    // Looping scene videos: play only the active scene's video (iOS needs the
    // muted/playsInline properties set, not just the attributes).
    function playVideo(step) {
      steps.forEach(function (s) {
        var v = s.querySelector('video');
        if (!v) return;
        if (s === step) {
          v.muted = true; v.defaultMuted = true; v.playsInline = true;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) { v.pause(); }
      });
    }

    function ui() {
      segs.forEach(function (s, i) { s.classList.toggle('is-done', i <= cur); });
      if (back) back.hidden = cur === 0;
      if (skip) skip.hidden = cur === steps.length - 1;
      loadImg(steps[cur + 1]);
    }

    function go(n, fromNext) {
      if (n < 0 || n >= steps.length || n === cur) return;
      var from = steps[cur], to = steps[n];
      if (fromNext) track(prefix, 'step_' + (cur + 1) + '_complete', { step: cur + 1 });
      from.classList.add('is-leaving');
      from.classList.remove('is-active');
      setTimeout(function () { from.classList.remove('is-leaving'); }, 340);
      loadImg(to);
      to.classList.add('is-active');
      var sc = to.querySelector('.pst-step__scroll');
      if (sc) sc.scrollTop = 0;
      cur = n;
      playVideo(to);
      if (n > furthest) furthest = n;
      if (to.classList.contains('pst-step--offer')) confetti(to);
      ui();
    }

    function close() {
      root.classList.add('pst--closed');
      // Alia's time-on-page trigger counts from page load, so releasing it now
      // would pop it instantly; wait the popup's own delay after Claim instead.
      var d = parseFloat(root.getAttribute('data-popup-delay'));
      setTimeout(releasePopups, (isNaN(d) ? 20 : d) * 1000);
      document.documentElement.classList.remove('pst-open');
      playVideo(null);
      var target = null;
      try { target = document.querySelector(targetSel); } catch (e) {}
      if (target) {
        // Wait a frame so the page has its real layout before measuring.
        requestAnimationFrame(function () {
          // The buy box is usually the first section, so show it from the very
          // top (header + full gallery) instead of cutting the gallery off.
          var y = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: y < window.innerHeight * 0.6 ? 0 : y - 8, behavior: 'auto' });
        });
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pst-next],[data-pst-back],[data-pst-skip],[data-pst-offer],[data-pst-replay]');
      if (!t || !root.contains(t)) { tapZone(e); return; }
      if (t.hasAttribute('data-pst-next')) go(cur + 1, true);
      else if (t.hasAttribute('data-pst-back')) go(cur - 1, false);
      else if (t.hasAttribute('data-pst-skip')) { track(prefix, 'offer_skip', { from_step: cur + 1 }); go(steps.length - 1, false); }
      else if (t.hasAttribute('data-pst-replay')) { track(prefix, 'replay'); go(0, false); }
      else if (t.hasAttribute('data-pst-offer')) {
        e.preventDefault();
        track(prefix, 'offer_click', { furthest_step: furthest + 1 });
        close();
      }
    });

    // Instagram-style tap zones: left third = back, rest = forward. Ignored on
    // links, buttons, the reviews carousel and when the visitor is selecting text.
    function tapZone(e) {
      var step = e.target.closest('[data-pst-step]');
      if (!step || !step.classList.contains('is-active')) return;
      if (e.target.closest('a,button,input,select,textarea,label,[data-pst-carousel]')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length) return;
      var r = step.getBoundingClientRect();
      if (e.clientX - r.left < r.width / 3) go(cur - 1, false);
      else if (cur < steps.length - 1) { track(prefix, 'tap_forward', { step: cur + 1 }); go(cur + 1, true); }
    }

    document.addEventListener('keydown', function (e) {
      if (root.classList.contains('pst--closed')) return;
      if (e.key === 'ArrowRight' && cur < steps.length - 1) go(cur + 1, true);
      if (e.key === 'ArrowLeft') go(cur - 1, false);
    });

    // Reviews carousel dots
    Array.prototype.forEach.call(root.querySelectorAll('[data-pst-carousel]'), function (car) {
      var cards = car.querySelectorAll('.pst-rev');
      var dots = car.parentNode.querySelector('[data-pst-dots]');
      if (!dots || cards.length < 2) return;
      for (var i = 0; i < cards.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (dots.getAttribute('data-review-label') || 'Review [n]').split('[n]').join(String(i + 1)));
        (function (idx) { b.addEventListener('click', function () { car.scrollTo({ left: cards[idx].offsetLeft - car.offsetLeft - 22, behavior: 'smooth' }); }); })(i);
        dots.appendChild(b);
      }
      var btns = dots.querySelectorAll('button');
      function mark() {
        var w = cards[0].offsetWidth + 10;
        var idx = Math.min(cards.length - 1, Math.round(car.scrollLeft / w));
        for (var j = 0; j < btns.length; j++) btns[j].classList.toggle('is-active', j === idx);
      }
      car.addEventListener('scroll', mark, { passive: true });
      mark();
    });

    function confetti(step) {
      var box = step.querySelector('.pst-confetti');
      if (!box || box.children.length) return;
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var colors = ['#FFB38A', '#FF6B3D', '#FFD3BA', '#E54A1F', '#FFF4EC', '#FF8A5C'];
      for (var i = 0; i < 48; i++) {
        var p = document.createElement('span');
        var round = i % 6 === 0;
        var w = 6 + Math.round(Math.random() * 5);
        p.className = 'pst-confetti__piece' + (round ? ' is-round' : '');
        p.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;width:' + w + 'px;height:' + (round ? w : w + Math.round(Math.random() * 8)) + 'px;background:' + colors[i % colors.length] +
          ';--delay:' + (Math.random() * 1.1).toFixed(2) + 's;--dur:' + (2.6 + Math.random() * 1.9).toFixed(2) + 's;--drift:' + Math.round(Math.random() * 80 - 40) + 'px;--spin:' + Math.round(540 + Math.random() * 540) + 'deg';
        box.appendChild(p);
      }
    }

    // Theme editor: selecting a block jumps to that scene.
    if (designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var el = e.target.closest && e.target.closest('[data-pst-step]');
        if (!el || !root.contains(el)) return;
        root.classList.remove('pst--closed');
        document.documentElement.classList.add('pst-open');
        go(steps.indexOf(el), false);
      });
    }

    track(prefix, 'step_1_view', { step: 1 });
    ui();
    playVideo(steps[0]);
    // Autoplay can be refused (Low Power Mode); retry on the first touch.
    document.addEventListener('touchstart', function once() { playVideo(steps[cur]); document.removeEventListener('touchstart', once); }, { passive: true });
  }

  function releasePopups() {
    try { if (typeof window.__pstReleasePopups === 'function') window.__pstReleasePopups(); } catch (e) {}
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-pst]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-pst]'); if (r) init(r); });
})();
